// extracted by mini-css-extract-plugin
export var deleteModal = "_sz-0";